import {
    SET_VISIBLE,
    SET_WORK_IN_PROGRESS,
    SHOW_ALERT,
    DISMISS_ALERT,
} from './Actions';


const initialState = {
    visibilityMap: {},
    backgroundWorkMap: {},
    error: null,
    message: null,
};

const UIReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_VISIBLE: {
            return {
                ...state,
                visibilityMap: {
                    ...state.visibilityMap,
                    [action.name]: action.show,
                },
            };
        }

        case SET_WORK_IN_PROGRESS: {
            return {
                ...state,
                backgroundWorkMap: {
                    ...state.backgroundWorkMap,
                    [action.name]: action.value,
                },
            };
        }

        case SHOW_ALERT: {
            return {
                ...state,
                message: action.message,
            };
        }

        case DISMISS_ALERT: {
            return {
                ...state,
                message: null,
            };
        }

        default:
            return state;
    }
};

export default UIReducer;
